function progressRowClass(status) {
    if (status === 'enriching') return 'loading';
    if (status === 'done') return 'done';
    if (status === 'needs_review') return 'warn';
    if (status === 'failed') return 'error';
    return 'pending';
}

export default function Step4Progress({ jobStatus }) {
    const rows = jobStatus?.results ?? [];
    const totalRows = jobStatus?.total ?? rows.length;

    return (
        <div className="bulk-state">
            <div className="bulk-state-title">Step 4 of 4 · Enrichment in progress</div>
            <h3>Processing {totalRows} properties · 3 at a time</h3>
            <div className="progress-table">
                {rows.map((row) => (
                    <div
                        className={`progress-row ${progressRowClass(row.status)}`}
                        key={row.rowIndex}
                    >
                        <span className="row-num">#{row.rowIndex}</span>
                        <span className="row-addr">{row.address}</span>
                        <span className="row-status">
                            {row.status === 'enriching' && (
                                <>
                                    <span className="progress-spinner" />
                                    {' '}
                                    Enriching…
                                </>
                            )}
                            {row.status === 'done' && '✓ Done'}
                            {row.status === 'needs_review' && '⚠ Needs review'}
                            {row.status === 'failed' && '✗ Failed'}
                            {row.status === 'pending' && 'Pending'}
                        </span>
                    </div>
                ))}
            </div>
        </div>
    );
}
